var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,16c-0.152,0-0.304-0.053-0.428-0.158c-0.648-0.553-6.336-5.505-6.336-9.079C1.236,3.034,4.271,0,8,0 c3.729,0,6.764,3.034,6.764,6.763c0,3.574-5.687,8.526-6.336,9.079C8.305,15.947,8.152,16,8,16L8,16z M8,1.32 c-3.001,0-5.445,2.442-5.445,5.444c0,2.317,3.602,6.039,5.445,7.698c1.843-1.659,5.445-5.381,5.445-7.698 C13.445,3.762,11.003,1.32,8,1.32L8,1.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,10.062c-1.818,0-3.299-1.48-3.299-3.299c0-1.819,1.481-3.299,3.299-3.299c1.82,0,3.299,1.48,3.299,3.299 C11.299,8.582,9.82,10.062,8,10.062L8,10.062z M8,4.784c-1.091,0-1.979,0.888-1.979,1.979S6.908,8.743,8,8.743 s1.979-0.888,1.979-1.979S9.091,4.784,8,4.784L8,4.784z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c289be0c646ebe43f1c1d64d25bbd4e2.svg";
export { ForwardRef as ReactComponent };